import styled from 'styled-components';
import { DARK_VIOLET, NEUTRAL_100, PALE_BLUE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const Container = styled.div`
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
`;

export const TitleContainer = styled.div`
  padding: 16px 12px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${NEUTRAL_100};
  background-color: ${PALE_BLUE};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const TitleText = styled.span`
  color: ${DARK_VIOLET};
  font-family: ${INTER.semiBold};
  font-size: 13px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 16px;
`;

export const OptionItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const OptionDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${NEUTRAL_100};
`;
